<template>
  <div class="uk-width-1-3@m uk-flex-first uk-first-column ad-sidebar-col">
    <div class="ad-sidebar-card">
      <!-- Cover Image -->
      <div class="ad-sidebar-image">
        <img :alt="item.name" :src="item.cover_image_link" />
      </div>

      <!-- Card Body -->
      <div class="ad-sidebar-body">
        <!-- Progress -->
        <div v-if="!item.provider" class="ad-progress-section">
          <div class="ad-progress-header">
            <span class="ad-progress-label">%{{ completionPct }} {{ $t("education.Completed") }}</span>
          </div>
          <div class="ad-progress-bar">
            <div class="ad-progress-fill" :class="progressBarClass" :style="progressBarStyle"
              :uk-tooltip="progressBarTooltip"></div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div v-if="startButton" class="ad-actions">
          <a :class="`ad-btn2 ad-btn--${startButton.variant}`" :uk-tooltip="startButton.tooltip || false" href="#"
            @click.prevent="startButton.handler && startButton.handler()">
            <i class="uil-forward"></i>
            <span>{{ $t(startButton.labelKey) }}</span>
          </a>
          <a v-if="collectionVisible" class="ad-btn2 ad-btn--outline" @click="$emit('add-collection')">
            <i class="uil-brightness-plus"></i>
            {{ $t("education.Add_collection") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssignmentSidebar",
  props: {
    item: { type: Object, required: true },
    completionPct: { type: Number, default: 0 },
    progressBarClass: { type: String, default: '' },
    progressBarStyle: { type: String, default: '' },
    progressBarTooltip: { type: String, default: '' },
    startButton: { type: Object, default: null },
    collectionVisible: { type: Boolean, default: false },
  },
  emits: ['add-collection'],
};
</script>
<style>
.ad-btn2 {
  display: flex ;
  align-items: center ;
  justify-content: center ;
  gap: 8px;
  padding: 12px 20px ;
  border-radius: 10px ;
  font-size: 14px ;
  font-weight: 600 ;
  text-decoration: none ;
  cursor: pointer ;
  transition: all 0.2s ease ;
  border: none;
}
</style>
